import { NoddiIcon } from 'noddi-ui-common';

type Props = {
  /** Bold lead-in — the sheets pass "View only" when nothing on them can be changed. */
  leadIn?: string;
  /** One sentence per locked capability, joined into a single compact paragraph. */
  reasons: string[];
};

/**
 * Says once, at the top of a sheet, what the viewer may not change — instead of
 * repeating a reason under every locked section.
 */
export const RestrictionNote = ({ leadIn, reasons }: Props) => {
  if (reasons.length === 0) {
    return null;
  }

  return (
    <p className='flex items-start gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2 text-sm text-blue-900'>
      <NoddiIcon name='Lock' size='small' className='mt-0.5 shrink-0 text-blue-600' />
      <span>
        {leadIn && <span className='font-semibold'>{`${leadIn} · `}</span>}
        {reasons.join(' ')}
      </span>
    </p>
  );
};
